var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-inline-flex"},[_c('Maintenancerescheduleduedate',{attrs:{"dataMaintenanceRecord":_vm.maintenance}}),_c('Maintenancecancel',{attrs:{"dataMaintenanceRecord":_vm.maintenance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }